import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-hidden focus:ring-2 focus:ring-coronis-blue-500 focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "bg-coronis-navy-600 text-white dark:bg-coronis-navy-500",
        secondary:
          "bg-coronis-blue-100 text-coronis-navy-600 dark:bg-coronis-blue-900/40 dark:text-coronis-blue-300",
        destructive:
          "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300",
        outline:
          "border border-coronis-navy-200 text-coronis-navy-600 dark:border-slate-600 dark:text-slate-300",
        success:
          "bg-coronis-teal-100 text-coronis-teal-700 dark:bg-coronis-teal-900/40 dark:text-coronis-teal-300",
        warning:
          "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
        info: "bg-coronis-blue-100 text-coronis-blue-700 dark:bg-coronis-blue-900/40 dark:text-coronis-blue-300",
        // Pipeline status variants
        running:
          "bg-coronis-teal-100 text-coronis-teal-700 ring-1 ring-coronis-teal-200 dark:bg-coronis-teal-900/40 dark:text-coronis-teal-300 dark:ring-coronis-teal-700",
        stopped:
          "bg-coronis-gray-100 text-coronis-gray-600 ring-1 ring-coronis-gray-200 dark:bg-slate-700 dark:text-slate-300 dark:ring-slate-600",
        error:
          "bg-red-100 text-red-700 ring-1 ring-red-200 dark:bg-red-900/40 dark:text-red-300 dark:ring-red-700",
        pending:
          "bg-amber-100 text-amber-700 ring-1 ring-amber-200 dark:bg-amber-900/40 dark:text-amber-300 dark:ring-amber-700",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
